import React from "react";
import './style.scss'
export default function PortfolioItem({imageUrl, title, description, link}) {
    return (
        <div className="col-md-4">
            <div className="card">
                <img src={imageUrl} className="card-img-top" alt={title} />
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <p className="card-text">{description}</p>
                    <div className="row">
                        <div className="col">
                            <a href={link} className="btn btn-primary">View more</a>
                        </div>
                        <div className="col">
                            <a href={link} className="btn btn-primary">Visit project</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
}